// Згенеровано Tools/gen_frontend.py з визначень модулів. Не редагувати вручну: зміни моделі — у визначенні модуля
// Solutions/Metadata/<Група>/<Модуль>/module.definition.json (каталог Design — похідний), власні подання — у views/ пакета.

import type { IRecordTypeDefinition } from '@platform/core/types';
import { assembleViewSet } from '@platform/core/lib/assembleViewSet';
import positionPaperEvidenceEntity from './entities/position-paper-evidence.json';
import positionPaperEvidenceMenu from '../pages/position-paper-evidence/menu.json';
import positionPaperEvidenceFullForm from '../pages/position-paper-evidence/forms/full.json';
import positionPaperEvidenceContextForm from '../pages/position-paper-evidence/forms/context.json';
import positionPaperEvidenceMiniForm from '../pages/position-paper-evidence/forms/mini.json';
import positionPaperEvidenceLookupForm from '../pages/position-paper-evidence/forms/lookup.json';
import positionPaperEvidenceTableView from '../pages/position-paper-evidence/views/table.json';
import positionPaperEvidenceCardsView from '../pages/position-paper-evidence/views/cards.json';
import positionPaperEvidenceDashboardView from '../pages/position-paper-evidence/views/dashboard.json';

/** Тип запису «Підтверджувальні дані» зі сторінками пакета: меню, форми та подання з pages/position-paper-evidence/. */
export const positionPaperEvidenceDefinition: IRecordTypeDefinition = {
  ...positionPaperEvidenceEntity,
  views: assembleViewSet({
      table: positionPaperEvidenceTableView,
      cards: positionPaperEvidenceCardsView,
      dashboard: positionPaperEvidenceDashboardView,
  }),
  form: positionPaperEvidenceFullForm,
  forms: { full: positionPaperEvidenceFullForm, context: positionPaperEvidenceContextForm, mini: positionPaperEvidenceMiniForm, lookup: positionPaperEvidenceLookupForm },
  menu: positionPaperEvidenceMenu,
} as IRecordTypeDefinition;
